import { useState } from 'react';
import styled from 'styled-components';

import derProdutosDaf from '../../assets/imagensDERs/sisafDerModuloProdutosDaf.png';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 1.15rem;
  text-align: justify;
  padding: 5px;

  ul {
    margin-bottom: 15px;
  }
`;

const Definicao = styled.div`
  margin-bottom: 20px;
`;

const AbasContainer = styled.div`
  display: flex;
  border-bottom: 2px solid #b0c4de;
  margin-bottom: 15px;
`;

const Aba = styled.div<{ active: boolean }>`
  padding: 10px 20px;
  cursor: pointer;
  font-weight: ${({ active }) => (active ? 'bold' : 'normal')};
  background-color: ${({ active }) => (active ? '#869ddb83' : 'transparent')};
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;

  &:hover {
    background-color: #b0c4de;
  }
`;

const ImagemDer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 15px;
  border-radius: 10px;
  border: 1px solid lightgray;
  background-color: lightgray;
  margin-bottom: 25px;

  img {
    height: 30vh;
    border-radius: 10px;
    width: auto;

    transition: transform 0.3s ease-in-out;

    &:hover {
      /* transform: scale(1.5); */
    }
  }
`;

const AbaDefinicoes = () => {
  return (
    <>
      <ul>
        <li>
          <b>Denominação Genérica</b>
        </li>
        <ul>
          <li>
            Refere-se ao nome comum ou científico de um princípio ativo
            utilizado em medicamentos. Esse nome é padronizado e reconhecido
            oficialmente, diferenciando-se de nomes comerciais ou de marcas
            registradas. A utilização de denominações genéricas visa facilitar a
            identificação dos medicamentos de acordo com o princípio ativo,
            garantindo uma nomenclatura uniforme e acessível para profissionais
            de saúde e pacientes.
          </li>
        </ul>

        <li>
          <b>Produto Farmacêutico</b>
        </li>
        <ul>
          <li>
            Qualquer substância, material, equipamento ou dispositivo destinado
            à prevenção, diagnóstico, tratamento, reabilitação ou manutenção da
            saúde humana. Isso inclui tanto medicamentos, que possuem
            propriedades farmacológicas, imunológicas ou metabólicas para tratar
            ou prevenir doenças, quanto insumos, como agulhas, gases, talas e
            outros materiais, que desempenham um papel de apoio essencial nos
            cuidados com a saúde, sem necessariamente exercerem efeito
            terapêutico direto.
          </li>
        </ul>

        <li>
          <b>Tags do Produto Farmacêutico</b>
        </li>
        <ul>
          <li>
            Referem-se a classificações, atributos ou rótulos que podem ser
            associados a um produto farmacêutico para facilitar sua organização
            e identificação. Elas funcionam como palavras-chave ou categorias
            que permitem agrupar produtos com características semelhantes, como
            composição, finalidade terapêutica, forma farmacêutica, ou
            regulamentações específicas. As tags são úteis para otimizar a
            busca, filtragem e classificação de produtos no SisAF, permitindo
            uma navegação mais eficiente e personalizada de acordo com as
            necessidades dos usuários ou profissionais de saúde.
          </li>
        </ul>

        <li>
          <b>Incorporação na Política de Assistência Farmacêutica</b>
        </li>
        <ul>
          <li>
            Refere-se ao processo pelo qual um produto de saúde, como
            medicamentos ou insumos, é formalmente incluído no Sistema Único de
            Saúde (SUS) para ser disponibilizado à população através da Política
            de Assistência Farmacêutica. Esse processo envolve a análise técnica
            e econômica do produto, considerando sua eficácia, segurança e
            impacto financeiro, e é regulamentado por portarias do Ministério da
            Saúde. Uma vez incorporado, o produto passa a ser distribuído em
            nível nacional, regional ou local, dentro das diferentes categorias
            de financiamento da Assistência Farmacêutica, como componentes
            básicos, especializados ou estratégicos.
          </li>
        </ul>

        {/* <li>
          <b>CID-10</b>
        </li>
        <ul>
          <li>
            O "CID-10" (Classificação Internacional de Doenças - 10ª Revisão) é
            um sistema de codificação utilizado globalmente para classificar e
            identificar doenças e outros problemas relacionados à saúde. Ele
            serve como uma ferramenta padronizada para registrar diagnósticos
            médicos, facilitando a coleta e a análise de dados epidemiológicos,
            clínicos e estatísticos. No contexto da Política de Assistência
            Farmacêutica, o CID-10 é utilizado para associar produtos
            farmacêuticos a condições ou doenças específicas, garantindo que os
            tratamentos sejam oferecidos de forma direcionada e adequada aos
            diagnósticos estabelecidos.
          </li>
        </ul> */}

        <li>
          <b>Kit de Produtos Farmacêuticos</b>
        </li>
        <ul>
          <li>
            Refere-se a um conjunto pré-definido de medicamentos e/ou insumos
            agrupados com o objetivo de facilitar o tratamento de uma condição
            específica ou atender a uma necessidade terapêutica determinada.
            Esses kits são organizados para garantir que todos os itens
            essenciais para o tratamento estejam disponíveis em uma única
            unidade, promovendo eficiência no fornecimento de cuidados de saúde.
            No SisDAF, um kit de produtos farmacêuticos pode incluir múltiplos
            itens, e suas informações são gerenciadas para facilitar a
            organização, distribuição e rastreamento dentro do sistema.
          </li>
        </ul>
      </ul>
    </>
  );
};

const Entidades = () => {
  return (
    <>
      <ImagemDer>
        <img src={derProdutosDaf}></img>
      </ImagemDer>

      <b>Entidades</b>
      <ul>
        <li>
          <b>TB_DENOMINACAO_GENERICA</b>
        </li>
        <ul>
          <li>
            Entidade que armazena a lista de denominações genéricas dos produtos
            farmacêuticos.
          </li>
        </ul>

        <li>
          <b>TB_PRODUTO_DAF</b>
        </li>
        <ul>
          <li>
            Entidade que organiza as principais informações dos produtos
            farmacêuticos administrados pelo DAF.
          </li>
        </ul>

        <li>
          <b>TB_TAG_PRODUTO</b>
        </li>
        <ul>
          <li>
            ‘Tags’ de marcação, categorização e/ou classificação dos produtos
            farmacêuticos em políticas públicas, grupos de doenças, linhas de
            financiamento ou outros. As tags facilitam a classificação dos
            produtos por diferentes parâmetros.
          </li>
        </ul>

        <li>
          <b>TB_PACTUACAO_AF</b>
        </li>
        <ul>
          <li>
            Entidade que organiza as informações sobre a pactuação do produto
            farmacêutico na Política de Assistência Farmacêutica do SUS.
          </li>
        </ul>

        <li>
          <b>TB_KIT_PRODUTO</b>
        </li>
        <ul>
          <li>
            Entidade que armazena informações sobre os kits de produtos
            farmacêuticos.
          </li>
        </ul>

        <li>
          <b>RL_KIT_PRODUTO_DAF_MANY</b>
        </li>
        <ul>
          <li>Entidade que relaciona kits e Produtos DAF.</li>
        </ul>
      </ul>

      <b>Cardinalidades</b>
      <ul>
        <li>
          <b>TB_DENOMINACAO_GENERICA para TB_PRODUTO_DAF</b>
        </li>
        <ul>
          <li>
            Cada registro em TB_PRODUTO_DAF tem uma única denominação genérica
            associada, e uma denominação genérica pode se aplicar a muitos
            produtos farmacêuticos.
          </li>
        </ul>

        <li>
          <b>TB_PRODUTO_DAF para TB_PACTUACAO_AF</b>
        </li>
        <ul>
          <li>
            Um registro de TB_PRODUTO_DAF pode mais de um relacionamento com a
            entidade TB_PACTUACAO_AF, que contém informações o status de
            incorporação do mesmo na Assistência Farmacêutica.
          </li>
        </ul>

        <li>
          <b>TB_PRODUTO_DAF para TB_TAG_PRODUTO</b>
        </li>
        <ul>
          <li>
            Um registro de TB_PRODUTO_DAF pode ter nenhuma ou várias tags
            associadas.
          </li>
        </ul>

        <li>
          <b>TB_PRODUTO_DAF para TB_KIT_PRODUTO</b>
        </li>
        <ul>
          <li>
            Um produto farmacêutico pode estar relacionado a vários kits de
            produtos e, da mesma forma, um kit de produtos pode estar
            relacionado a vários produtos farmacêuticos. O relacionamento entre
            essas entidades se dá através da RL_KIT_PRODUTO_DAF_MANY.
          </li>
        </ul>
      </ul>
    </>
  );
};

const RegrasDeNegocio = () => {
  return (
    <>
      <ul>
        <li>
          <b>Denominação Genérica</b>
        </li>
        <ul>
          <li>
            Não podem existir denominações com o mesmo nome. Cada denominação
            genérica é única.
          </li>
          <li>
            Não é possível deletar uma denominação genérica caso esteja
            vinculada a um produto farmacêutico.
          </li>
        </ul>

        <li>
          <b>Produto Farmacêutico</b>
        </li>
        <ul>
          <li>
            Para cadastrar um produto farmacêutico é necessário ter cadastrado
            antes a Denominação Genérica.
          </li>
          <li>
            A identificação única do nome produto é composto por:<br></br>
            <b
              style={{
                background: '#faff73',
                padding: '10px',
                borderRadius: '10px',
                lineHeight: '3',
              }}
            >
              Denominação Genérica + Forma Farmacêutica + Concentração
            </b>
          </li>
          <li>
            Não é possível registrar Produto Farmacêutico com o mesmo nome.
          </li>
          <li>
            Não é possível deletar um produto farmacêutico caso ele esteja
            relacionado a um processo aquisitivo ou contrato.
          </li>
        </ul>

        <li>
          <b>Kit de Produtos Farmacêuticos</b>
        </li>
        <ul>
          <li>
            Para cadastrar um Kit de Produtos Farmacêuticos é necessário que os
            Produtos já estejam cadastrados.
          </li>
          <li>Não é possível registrar um Kit de Produtos com o mesmo nome.</li>
          <li>
            Não é possível deletar um Kit de Produtos Farmacêuticos caso ele
            esteja relacionado a um processo aquisitivo ou contrato.
          </li>
        </ul>
      </ul>
    </>
  );
};

const AjudaModuloProdutoDaf = () => {
  const [abaAtiva, setAbaAtiva] = useState<
    'definicoes' | 'regras' | 'entidades'
  >('definicoes');

  return (
    <Container>
      <Definicao>
        Módulo que{' '}
        <b>
          centraliza as informações dos produtos farmacêuticos administrados
          pelo DAF
        </b>
        . É um módulo central, pois, praticamente, todas as operações do SisAF
        giram em torno dos produtos farmacêuticos.
      </Definicao>

      {/* Abas */}
      <AbasContainer>
        <Aba
          active={abaAtiva === 'definicoes'}
          onClick={() => setAbaAtiva('definicoes')}
        >
          Definições
        </Aba>
        <Aba
          active={abaAtiva === 'entidades'}
          onClick={() => setAbaAtiva('entidades')}
        >
          Entidades
        </Aba>
        <Aba
          active={abaAtiva === 'regras'}
          onClick={() => setAbaAtiva('regras')}
        >
          Regras de Negócio
        </Aba>
      </AbasContainer>

      {/* Conteúdo da Aba Ativa */}
      {abaAtiva === 'definicoes' ? (
        <AbaDefinicoes />
      ) : abaAtiva === 'regras' ? (
        <RegrasDeNegocio />
      ) : (
        <Entidades />
      )}
    </Container>
  );
};

export default AjudaModuloProdutoDaf;
